import axios from "axios";

export const createCollaudo = async (collaudo) => {
    const response = await axios.post(`/api/collaudi`, { collaudo });
    return response.data;
};

export const completeGisPhase = async collaudo => {
    const response = await axios.put(`/api/collaudi/giscomplete`, { collaudo });
    return response.data;
};

export const updateCollaudo = async collaudo => {
    const response = await axios.put(`/api/collaudi`, { collaudo });
    return response.data;
};

export const getCollaudo = async id => {
    const response = await axios.get(`/api/collaudi/${id}`);
    return response.data;
};

export const updateCollaudoBot = async (id, testcache) => {
    const response = await axios.put(`/api/collaudi/updatebot/${id}`, testcache, { headers: { 'Content-Type': 'text/plain' } });
    return true
};

export const updateCollaudoDocs = async (id, docs) => {
    const response = await axios.put(`/api/collaudi/updatedocs/${id}`, { docs });
    return response.data
};

export const signCollaudo = async (id, doc, date_c) => {
    const response = await axios.put(`/api/collaudi/sign/${id}`, { doc, date_c });
    return response.data
};

export const getCollaudoBot = async (id) => {
    const response = await axios.get(`/api/collaudi/getbot/${id}`, {
        transformResponse: (data) => {
            return data;
        }
    });
    return response.data
};

export const deleteBot = async (id) => {
    const response = await axios.delete(`/api/collaudi/bot/${id}`);
    return response.data
};

export const getCollaudiForSale = async (idSale) => {
    const response = await axios.get(`/api/collaudi-sale/${idSale}`);
    return response.data
};

export const deleteDraft = async (id) => {
    const response = await axios.delete(`/api/collaudi-draft/${id}`);
    return response.data
};

export const deleteCollaudo = async id => {
    const response = await axios.delete(`/api/collaudi/${id}`);
    return response.data;
};
